
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import NevronAdvanceTextBox from "@/components/NevronAdvanceTextBox.vue";
import NevronImageField from "@/components/NevronImageField.vue";
import TableGeneric from "@/components/NevronTableGeneric.vue";
import NevronInput from "@/components/NevronInput.vue";
import Multiselect from "vue-multiselect";
import AttachItem from "@/modules/Packages/Attachpackageitem.vue";
import stores from "@/stores";

@Component({
  components: {
    AttachItem,
    Multiselect, NevronInput, TableGeneric, NevronImageField, NevronAdvanceTextBox}
})
export default class MessageContent extends Vue {

  @Prop({required: true})
  messageContent!: IMessageContent;

  @Prop({default: 0})
  refresh!: number;

  localMessageContent: IMessageContent = {
    type: 'TV',
    title: "",
    text: "",
    iconFilename: undefined,
    hasButton: false,
    buttonText: undefined,
    linkedItemId: undefined,
    linkedItemType: undefined,
    imageId: undefined,
    image: undefined,
  };

  selectedIcon: { name: string, filename: string } | null = null;


  icons = [
    {
      name: 'bell',
      filename: "bell-icon.svg",
    },
    {
      name: 'special-notice',
      filename: "special-notice-icon.svg",
    },
    {
      name: 'special-offer',
      filename: "special-offer-icon.svg",
    },
    {
      name: 'thumbs-up',
      filename: "thumbs-up-icon.svg",
    },
    {
      name: 'urgent',
      filename: "urgent-icon.svg",
    },
    {
      name: 'wellness',
      filename: "wellness-icon.svg",
    }
  ];

  stores = stores;


  get showTitle() {
    return this.localMessageContent.type !== 'SMS';
  }

  get showDescription() {
    return ['tv', 'mobile', 'EMAIL', 'SMS'].includes(this.localMessageContent.type);
  }

  get showImage() {
    return ['tv', 'mobile', 'EMAIL'].includes(this.localMessageContent.type);
  }

  get showIcon() {
    return ['mobile'].includes(this.localMessageContent.type);
  }

  get showButton() {
    return ['tv', 'mobile'].includes(this.localMessageContent.type);
  }

  get titleId() {
    return `message-${this.localMessageContent.type.toLowerCase()}-title`;
  }


  get linkedItemModule(): IModule | null {
    if (this.localMessageContent?.linkedItem) {
      return stores.modules.get(this.localMessageContent.linkedItem.moduleId) || null;
    }
    return null;
  }

  @Watch('localMessageContent', {deep: true})
  updateMessageContent() {
    this.$emit('updateMessageContent', this.localMessageContent);
  }

  @Watch('selectedIcon', {deep: true})
  updateIcon() {
    this.localMessageContent.iconFilename = this.selectedIcon?.name || undefined;
  }

  @Watch('refresh')
  updateRefresh() {
    this.init();
  }

  created() {
    this.init();
  }

  init() {
    this.createLocalMessageContent(this.messageContent);
    this.selectedIcon = this.icons.find(icon => icon.name === this.localMessageContent.iconFilename) || null;
  }

  createLocalMessageContent(data: IMessageContent) {
    this.localMessageContent = {
      type: data.type,
      messageId: data.messageId || undefined,
      id: data.id || undefined,
      title: data.title || "",
      text: data.text || "",
      iconFilename: data.iconFilename || "",
      hasButton: data.hasButton || undefined,
      buttonText: data.buttonText || "",
      linkedItemId: data.linkedItemId || undefined,
      linkedItemType: data.linkedItemType || undefined,
      linkedItem: data.linkedItem || undefined,
      imageId: data.imageId || undefined,
      image: data.image || undefined,
    }
  }

  linkItem(item: IItem | null) {
    this.localMessageContent.linkedItemId = item?.id || undefined;
    this.localMessageContent.linkedItemType = item?.entityName || undefined;
    this.$set(this.localMessageContent, 'linkedItem', item || undefined);
  }

  imageSelected(image: IMediaItem | null) {
    this.localMessageContent.image = image ?? undefined;
    this.localMessageContent.imageId = image?.id ?? null;
  }

}
